import axios from 'axios';
import {createAuthorizationTokenHeader} from './auth';

const protocol="https://";
const url="rambl.in";
const port ="8333";
/**
* Authorize user
**/
export const getAllUnapprovedComments = () => {

  const req = axios.get(protocol+url+':'+port+'/bullards-api/getAllUnapprovedReviews',
              {
                headers: createAuthorizationTokenHeader()
              }
  ).then(res => {
        return res;
    }
  ).catch(error=> {
    // handle error
    throw error;
  })
  return req
}


export const approveReview = (id) => {

  const req = axios.post(protocol+url+':'+port+'/bullards-api/updateReviewApprovedState/'+id,
              {
                headers: createAuthorizationTokenHeader()
              }
  ).then(res => {
        return res;
    }
  ).catch(error=> {
    // handle error
    throw error;
  })
  return req
}